import { gamesOf, taskKey } from '@continuum/show-core';
import type { WireState, You } from '../room/client.js';

/*
 * The parts of a guest's own view that came with the stop's new steps (show-core `wire.ts` `You`,
 * 2026-10-06), absent from a room from before: read through here, with what the shared state already
 * shows as the fallback.
 */

/**
 * A saboteur's game of this stop is played, and its alarm is waiting for the end of the games. Without
 * the room's word, the shared state says it too: a saboteur never plays the games dealt to them, so once
 * the room has finished all of them, the sabotage is armed.
 */
export function armedOf(you: You | null | undefined, state?: WireState | null): boolean {
  if (!you) return false;
  if (you.armed !== undefined) return you.armed;
  if (!state || you.alignment !== 'PARADOX AGENT' || state.chapter < 1) return false;
  const dealt = gamesOf(state, state.chapter, you.seat);
  return dealt.length > 0 && dealt.every((index) => state.tasks[taskKey(state.chapter, index, you.seat)]?.done === true);
}

/** The eras this guest was a saboteur in, oldest first, as the room says (empty when it does not). */
export function saboteurAtOf(you: You | null | undefined): number[] {
  const at = you?.saboteurAt;
  return Array.isArray(at) ? [...at].sort((a, b) => a - b) : [];
}
